




























import { Vue, Component } from 'vue-property-decorator';
import Container from './Registration/Container.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import { vxm } from '@/store.vuex';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class TroubleLogin extends Vue {

  get tlSingleSupportNoPresent() {
    return vxm.configs.getGlobalConfigValue('TL_SUPPORT_PHONE_NUMBER') ? true : false;
  }
  get tlSupportPhoneNo() {
    return (
      vxm.configs.getGlobalConfigValue('TL_SUPPORT_PHONE_NUMBER') ||
      vxm.utility.supportPhoneNo
    );
  }

  get supportEmail() {
    return vxm.utility.supportEmail;
  }

  multiTelHref(value: string) {
    return `tel:${value}`;
  }

  get emailHref() {
    const subject = `Message from ${vxm.users.myUserProfile.email}`;
    return `mailto:${this.supportEmail}?subject=${subject}&body=Hello workllama support`;
  }

}
